class Banner {
  init() {
    this.links = document.querySelectorAll("[js-banner-scroll]");

    this.links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const scrollToEl = link.closest("section").nextElementSibling;
        const offsetModifier = document.querySelector("header").offsetHeight;
        const calculatedOffset = scrollToEl.getBoundingClientRect().top + window.scrollY - offsetModifier;

        window.scrollTo({
          top: calculatedOffset,
          behavior: "smooth",
        });
      });
    });
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./scripts/Banner.js